import { forwardRef } from "react"

import { SvgIcon, type SvgIconProps } from "@mui/material"
import type { ResponsiveStyleValue } from "@mui/system"

import { Link } from ".."

export interface LogoProps extends SvgIconProps {
  size?: {
    width: ResponsiveStyleValue<string | number>
    height: ResponsiveStyleValue<string | number>
  }
}

const Logo = forwardRef<SVGSVGElement, LogoProps>(
  ({ size = { width: 245, height: 65 }, sx, ...props }, ref) => {
    return (
      <Link
        href="/"
        type="base"
        aria-label="Goway.com"
        sx={{ display: "inline-block", lineHeight: 0 }}
      >
        <SvgIcon
          ref={ref}
          viewBox="0 0 651.7 187.94"
          sx={{
            width: size.width,
            height: size.height,
            fill: (theme) => theme.palette["primary.800"].main,
            ...sx,
          }}
          {...props}
        >
          <path d="M185.34,74.49c0,24.86-14.88,45.18-45.18,45.18s-45.18-20.32-45.18-45.18,14.51-45.18,45.18-45.18c30.3,0,45.18,20.32,45.18,45.18ZM159.5,74.64c0-20.17-3.85-40.2-19.34-40.2s-19.34,20.02-19.34,40.2,3.4,39.89,19.34,39.89,19.34-19.87,19.34-39.89Z" />
          <path d="M337.43,31.87l-13.3,15.49-24.86,69.74h-23.57l-17.91-50.24-17.91,50.24h-23.57l-25.39-71.02-11.11-14.2h43.9l-8.39,9.82,23.27,65.58,16.77-47.3-4.99-13.9-11.11-14.2h43.9l-8.39,9.82,23.27,65.58,21.61-61.05-13.9-14.36h31.66Z" />
          <path d="M422.8,111.28c-4.99,5.67-11.11,8.39-19.34,8.39-10.8,0-16.62-7.56-16.77-21.99-3.7,10.2-13.07,21.99-28.71,21.99-14.2,0-25.54-9.52-25.54-23.88,0-33.4,41.18-21.31,53.95-35.36-.83-12.62-4-25.99-15.79-25.99s-13.9,19.19-13.22,28.11l-19.8-18.13c5.82-6.65,15.19-15.19,37.17-15.19,25.01,0,37.78,10.96,37.78,40.04v34.91c-.08,7.78,7.71,8.76,10.28,7.1ZM386.61,87.86v-15.34c0-2.72,0-5.82-.15-9.07-9.37,14.66-30,8.54-29.39,29.54.68,19.27,29.54,13.75,29.54-5.14Z" />
          <path d="M43.07,97.08c-20.78-.83-27.96-4-26.97-13.22,6.2,2.72,14.36,4.31,24.71,4.31,27.58,0,40.88-11.94,40.88-28.56,0-8.92-3.85-17-12.09-22.44v-.08c-.53-.38-1.13-.68-1.74-1.06-.15-.08-.3-.15-.45-.23-.23-.15-.45-.23-.68-.38-4.08-2.12-9.07-3.7-14.88-4.61h-.08c-.6-.08-1.21-.15-1.81-.23-.15,0-.3,0-.45-.08-.53-.08-1.06-.08-1.59-.15-.3,0-.53-.08-.83-.08-.45,0-.91-.08-1.36-.08s-.83-.08-1.28-.08c-.38,0-.68,0-1.06-.08h-2.42C12.62,29.98,0,43.43,0,59.53c0,9.29,3.85,17.08,12.16,22.21-6.57,3.02-12.16,9.07-12.16,17.38,0,13.9,11.94,18.96,33.7,20.55,15.79,1.13,32.72,2.72,32.72,14.36,0,10.88-12.47,15.64-24.4,15.94-15.64.45-28.56-11.03-19.12-26.67-13.98.76-22.89,6.5-22.89,13.83,0,10.73,15.34,18.06,41.18,18.06,32.72,0,50.77-12.47,50.77-32.26s-19.64-24.63-48.88-25.84ZM40.88,35.12c11.18,0,15.34,11.03,15.34,23.65s-4.16,24.25-15.34,24.25-15.34-11.03-15.34-24.25c0-12.62,3.85-23.65,15.34-23.65Z" />
          <polygon
            points="87.95 46.38 94.97 21.75 70.11 27.87 82.51 34.06 87.95 46.38"
            style={{ fill: "#32456b" }}
          />
          <path d="M475.01,106.82l-4.08,10.35c-9.37,23.57-18.74,38.76-36.95,38.76-6.12,0-14.51-2.87-20.17-8.54l16.47-25.01c.68,19.34,22.59,21.99,29.24,8.69l-34.6-85-11.11-14.2h43.9l-8.39,9.82,23.42,58.78" />
          <polygon points="493.9 59.98 510.75 31.87 474.26 31.87 489.52 41.92 493.9 59.98" />
          <path
            style={{ fill: "#32456b" }}
            d="M542.95,187.94l-.9-9.65,1.3,2.66-12.26-16.5,4.81-.45,9.89,13.31-2.72.25,7.22-14.91,4.46-.42-8.97,18.48.75-2.85.9,9.65-4.5.42Z"
          />
          <path
            style={{ fill: "#32456b" }}
            d="M573.57,178.53l13.16-4.22,1.18,3.67-17.5,5.61-7.49-23.33,17.03-5.46,1.18,3.67-12.7,4.08,5.13,16ZM570.04,168.67l11.6-3.72,1.14,3.57-11.6,3.72-1.14-3.57Z"
          />
          <path
            style={{ fill: "#32456b" }}
            d="M596.56,174.6l-4.08-26.55,3.76-2.44,22.61,14.54-4.02,2.61-19.95-13.39,1.53-.99,4.06,23.69-3.91,2.53ZM597.73,167.08l-.89-3.68,11.07-7.18,2.97,2.33-13.16,8.53Z"
          />
          <path
            style={{ fill: "#32456b" }}
            d="M626.83,151.94l-18.85-15.65,6.44-7.76c1.38-1.67,2.84-2.88,4.36-3.64,1.52-.75,3.05-1.04,4.59-.85,1.54.19,3.01.86,4.42,2.02,1.38,1.15,2.3,2.45,2.75,3.92.45,1.47.45,3.02,0,4.66-.45,1.64-1.37,3.3-2.76,4.97l-4.8,5.79-.29-2.83,7.06,5.86-2.91,3.5ZM623.05,142.89l-2.97.13,4.67-5.63c1.28-1.54,1.92-2.98,1.9-4.31-.02-1.33-.62-2.49-1.8-3.47-1.19-.98-2.43-1.36-3.73-1.12-1.3.24-2.6,1.13-3.88,2.67l-4.67,5.63-.45-2.97,10.94,9.07ZM637.06,139.6l-10.8-.91,3.11-3.74,10.82.88-3.13,3.77Z"
          />
          <path
            style={{ fill: "#32456b" }}
            d="M649.99,119.48c-.88,1.7-1.97,3.19-3.26,4.48-1.29,1.29-2.56,2.2-3.81,2.73l-2.41-3.03c1.13-.51,2.26-1.29,3.39-2.34,1.12-1.05,2.03-2.24,2.74-3.59.59-1.14.95-2.12,1.07-2.96.12-.83.05-1.53-.2-2.08-.25-.55-.65-.97-1.18-1.25-.66-.34-1.32-.38-1.97-.12-.65.27-1.29.71-1.92,1.35s-1.29,1.36-1.96,2.18c-.68.82-1.4,1.61-2.17,2.38-.77.77-1.57,1.42-2.42,1.96-.84.53-1.76.84-2.75.92-.99.08-2.06-.19-3.22-.79-1.18-.61-2.1-1.49-2.75-2.64-.65-1.14-.94-2.51-.86-4.12.08-1.6.64-3.39,1.68-5.38.68-1.3,1.52-2.51,2.52-3.62,1-1.11,2.06-1.98,3.17-2.61l2.47,2.91c-1.09.67-2.04,1.45-2.86,2.34-.82.89-1.47,1.81-1.97,2.76-.57,1.1-.9,2.07-1,2.91-.1.84,0,1.54.27,2.09.28.55.69.97,1.22,1.25.66.34,1.32.39,1.96.13.65-.26,1.28-.7,1.9-1.34s1.28-1.37,1.97-2.19,1.41-1.62,2.17-2.38,1.55-1.41,2.4-1.95c.84-.53,1.75-.84,2.73-.93s2.04.17,3.17.77c1.16.6,2.07,1.48,2.72,2.62.65,1.14.94,2.52.85,4.13-.09,1.61-.65,3.41-1.69,5.4Z"
          />
          <path
            style={{ fill: "#32456b" }}
            d="M544.49,17.55h45l10.39-17.55h-56.06l-30.71,58.82c6.94-3.25,14.52-4.88,22.76-4.88,5.74,0,10.82.95,15.24,2.84,4.42,1.9,7.67,4.71,9.76,8.45,2.09,3.74,2.4,8.32.95,13.73-3.25,12.13-11.45,21.99-24.58,29.57-13.14,7.58-27.13,13-41.97,16.25l.36,4.71c9.16-.65,19.71-2.9,31.62-6.74,11.92-3.85,22.74-9.37,32.47-16.57,9.73-7.2,15.9-15.68,18.51-25.43,2.09-7.8,2.06-14.35-.09-19.66-2.15-5.31-5.84-9.23-11.06-11.78-5.22-2.54-11.35-3.82-18.4-3.82-4.77,0-8.99.38-12.65,1.14-2.54.53-5.09,1.22-7.66,2.05l.08-.03,16.04-31.11Z"
          />
          <path
            style={{ fill: "#32456b" }}
            d="M577.01,23.46l-10.27,19.67c1.53.5,3,1.08,4.39,1.76,1.23.6,2.38,1.29,3.44,2.04l3.06-5.93h45.05l10.39-17.55h-56.06Z"
          />
          <path
            style={{ fill: "#32456b" }}
            d="M600.27,72.78c-4.1-2-8.78-3.2-14-3.63.1,3.53-.34,7.34-1.32,11.41,4.08,1.89,7.13,4.6,9.11,8.14,2.09,3.74,2.4,8.32.95,13.73-3.25,12.13-11.45,21.99-24.58,29.57-13.14,7.58-27.13,13-41.97,16.25l.36,4.71c9.16-.65,19.71-2.9,31.62-6.74,11.92-3.85,22.74-9.37,32.47-16.57,9.73-7.2,15.9-15.68,18.51-25.43,2.09-7.8,2.06-14.35-.09-19.66-2.15-5.31-5.84-9.23-11.06-11.78Z"
          />
        </SvgIcon>
      </Link>
    )
  }
)
Logo.displayName = "Logo"

export default Logo
